export class OnlineRequestCategoryResultDto {
  categoryId: number;
  raCallTypeId: number;
  categoryName: string;
  issueName: string;
  callerType: string;
  callerTypeDescription: string;

  get displayName(): string {
    return `(${this.categoryName}) ${this.issueName}`;
  }
}
